import React, {useEffect, useState} from 'react';
import styles from "./checkRatings.module.scss";
import {useTickerRating} from "../../../hooks/tickerRating.hook";
import {TypesOfRating} from "../../../shared/types";
import {CountryExchange} from "../../../shared/countryExchange";
import {message as messageAnt} from "antd";
import dayjs from "dayjs";
import {useTranslation} from 'react-i18next';

type IRatingIsExpired = Record<TypesOfRating, { isExpired: boolean, dateOfExpiration: string }>

interface Props {
  countryExchange: CountryExchange | undefined
}

const CheckRatings = ({countryExchange}: Props) => {

  const {t, i18n} = useTranslation();

  const {loading: loadingTickerRating, getDateExpAllRatings, error: errorRating, clearError: clearErrorRating} = useTickerRating()

  const [ratingIsExpiredObject, setRatingIsExpiredObject] = useState<IRatingIsExpired>()//информация по актуальности фунд и тех рейтингов
  const [allRatingIsNotExpired, setAllRatingIsNotExpired] = useState<boolean>(false)//информация по актуальности фунд и тех рейтингов одновременно всех

  //проверка что все рейтинги одновременно актуальны
  useEffect(() => {
    if (!countryExchange) {
      setRatingIsExpiredObject(undefined)
      setAllRatingIsNotExpired(false)
    }
    if (ratingIsExpiredObject) {
      // if (!ratingIsExpiredObject.FUND.isExpired && !ratingIsExpiredObject.MEMB.isExpired) {//временно не проверяю рейтинг голосующих пользователей с сайта investing.com так как не ориентируюсь на них
      if (!ratingIsExpiredObject.FUND.isExpired) {
        setAllRatingIsNotExpired(true)
      } else {
        setAllRatingIsNotExpired(false)
      }
    }
  }, [ratingIsExpiredObject, countryExchange])

  //функция получение дат экспирации по рейтингам из БД
  const getDateExpAllRats = async (country: CountryExchange) => {
    try {
      const data = await getDateExpAllRatings(country)
      messageAnt.info(data.message)
      const ratings = data.info
      return ratings
    } catch (e) {
      messageAnt.info(errorRating);
      clearErrorRating()
      return undefined
    }
  }

  //изначальное получение актуальности рейтингов по датам экспирации
  useEffect(() => {
    const get = async () => {
      if (countryExchange) {
        const dateExpAllRats = await getDateExpAllRats(countryExchange)
        if (dateExpAllRats) {
          const ratingIsExpired: Partial<IRatingIsExpired> = {}
          dateExpAllRats.forEach((elem) => {
            ratingIsExpired[elem.typeOfRating] = {
              isExpired: dayjs(elem.dateOfExpiration) < dayjs(),
              dateOfExpiration: elem.dateOfExpiration
            }
          })
          setRatingIsExpiredObject(ratingIsExpired as IRatingIsExpired)
        }
      }
    }
    get()
  }, [countryExchange])

  if (!ratingIsExpiredObject || allRatingIsNotExpired) {
    return null
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.wrap}>
          {/*//@ts-ignore*/}
          <p className={styles.title}>{t('GetDataRatingIsExpired')}</p>
          <p className={styles.term}>
            {/*//@ts-ignore*/}
            {t('GetDataRatingDateOfExpFUND')}: {ratingIsExpiredObject.FUND.dateOfExpiration}
          </p>
          <p className={styles.term}>
            {/*//@ts-ignore*/}
            {t('GetDataRatingDateOfExpMEMB')}: {ratingIsExpiredObject.MEMB.dateOfExpiration}</p>
        </div>
      </div>
    </div>
  );
};

export default CheckRatings;